import React from 'react';
import SMUserResource from 'resources/SMUserResource';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import moment from 'moment';
import SMConst from 'lib/SMConst';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import SMUFavoriteListSelectView from 'components/dashboard/users/SMUFavoriteListSelectView';

class SMPromotionView extends React.Component {

  constructor(props) {
    super(props);
    this.promotionCouponType = {
      normal: 0,
      external: 1,
      pointCode: 2,
    };

    this.state = {
      mailUrl: '#',
      fbUrl: '#',
      lineUrl: '#',
      rooms: props.promotion.rooms,
      isSMUFavoriteListSelectViewOpen: false,
      latestUpdatedFavoriteList: {},
      targetFavoriteRoom: {},
    };
  }

  componentDidMount() {
    setTimeout(this.setSocialLinks.bind(this), 10);
  }

  trackPageEvent (label) {
     SMTrackHelper.pageEvent(label);
  }

  setSocialLinks() {
    const promotion = this.props.promotion;
    // mail
    const campaign = "promotion-" + promotion.id;
    let url = "http://" + location.host + Routes.promotion_path(promotion, {
      utm_campaign: campaign,
      utm_source: "email",
      utm_medium: "share",
    });
    const subject = promotion.title;
    const br = "%0d%0a";
    const body = sprintf(promotion.description + "%s%s",
      br + br,
      encodeURIComponent(url)
    );
    const mailUrl = sprintf("mailto:?subject=%s&body=%s", subject, body);

    // facebook
    const prefix = location.pathname.length && location.pathname[0] == "?" ? "&" : "?";
    url = location.href + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "facebook", "share"
    );
    const redirect = encodeURIComponent("https://spacemarket.com/");
    const fbUrl = sprintf("http://www.facebook.com/sharer/sharer.php?u=%s&amp;t=%s",
      encodeURIComponent(url), subject
    );

    // line
    url = location.href + sprintf("%sutm_campaign=%s&utm_source=%s&utm_medium=%s",
      prefix, campaign, "line", "share"
    );
    const lineUrl = sprintf("http://line.me/R/msg/text/?%s",
      encodeURIComponent(subject + " " + url),
    );
    this.setState({
      mailUrl: mailUrl,
      fbUrl: fbUrl,
      lineUrl: lineUrl,
    });
  }

  favoriteDidSelect(rowIndex, e) {
    e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }
    const isFavorite = $(e.currentTarget).hasClass("units-item-fav__on");
    const room = this.state.rooms[rowIndex];
    if (isFavorite) {
      // お気に入りに登録されている場合はモーダルを表示させる
      this.showFavoriteListSelectForm(room);
    } else {
      let responseHandler = (data, error, xhr)=>{
        let rooms = this.state.rooms;

        if (error) {
          room.is_favorite = false;
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
          });

        } else {
          room.is_favorite = true;
          room.registered_favorite_lists.push(data.favorite_list.id);
          rooms[rowIndex] = room;
          this.setState({
            rooms: rooms,
            targetFavoriteRoom: room,
            latestUpdatedFavoriteList: data.favorite_list,
            isOpenDefaultFavoriteList: true,
          });
          setTimeout(()=>{
            this.setState({
              isOpenDefaultFavoriteList: false,
            });
          }, 2000);
        }
      };

      SMUserResource.postFavorite(this.props.currentUser.username, room.id, 'Room', responseHandler);
    }
  }

  pointCodeDidSelect(e) {
    e.preventDefault();
    if (!this.props.currentUser) {
      SMAppHelper.redirectToLogin();
    }

    SMAppHelper.redirectTo(Routes.dashboard_points_available_point_histories_path());
  }

  showFavoriteListSelectForm(room, e){
    if (e) e.preventDefault();
    this.setState({
      targetFavoriteRoom: room,
      isSMUFavoriteListSelectViewOpen: true,
    });
  }

  // SMSearchListTableRow delegate
  favoriteListSelectViewDidClose() {
    this.setState({
      isSMUFavoriteListSelectViewOpen: false,
    });
  }

  renderCouponDescription(promotion, coupon) {
    if (promotion.coupon_type == this.promotionCouponType.normal) {
      if (!coupon) return null;
      let rows = [];
      //rows.push(
      //  <li key="search_query">このクーポンを利用できるスペースはすべてのスペースです。</li>
      //);
      if (coupon.redemption_limit_per_user) {
        rows.push(
          <li key="redemption_limit_per_user">このクーポンは1ユーザーにつき{coupon.redemption_limit_per_user}回利用することができます。</li>
        );
      }

      if (coupon.discount_type == SMConst.CouponDiscountType.Percentage) {
        rows.push(
          <li key="percentage">このクーポンは利用料金（スペース利用料とオプション・飲食を含む総額の税抜価格）から{Math.floor(coupon.percentage)}％を割引するものです。利用料金に消費税、サービス手数料は含まれません。</li>
        );
      }
      else if (coupon.discount_type == SMConst.CouponDiscountType.Amount) {
        rows.push(
          <li key="amount">このクーポンの最大割引金額は{Math.floor(coupon.amount)}円とします。</li>
        );
      }

      if (coupon.min_order_amount && coupon.min_order_amount > 0) {
        rows.push(
          <li key="min_order_amount">このクーポンは利用料金が{Math.floor(coupon.min_order_amount)}円以上の予約リクエストで利用できます。</li>
        );
      }
      return (
        <ul className="campaign-attention__list">
          <li>予約リクエスト送信時にクーポンコードを入力すると、クーポン割引適用後の金額が表示されます。必ず金額をご確認の上ご予約ください。</li>
          <li>否認、キャンセル、期限切れなど、予約リクエストが承認されなかった場合はクーポンは利用されなかったことになります。</li>
          <li>このクーポンは予約リクエスト送信時にクーポンの有効期限内である場合に利用することができます。</li>
          <li>このクーポンは数に限りがあります。最大発行数を超えた場合は利用できない場合があります。</li>
          <li>このクーポンは他のクーポン併用することはできません。</li>
          {rows}
          <li>このクーポンは予告なく終了する場合がございます。ご了承ください。</li>
        </ul>
      );
    } else {
      return (
        <div className="campaign-attention__edit">
          <p dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(promotion.external_coupon_agreement)}}></p>
        </div>
      );
    }
  }

  renderCampaignRooms(promotion, isPointCodePampaign) {
    if (isPointCodePampaign) {
      return null;
    }

    const moreUrl = promotion.search_query || Routes.search_index_path();

    return (
      <div className="page__odd campaign__padding">
        <div className="container">
          <h2 className="campaign-target__title"><span className="campaign-target__title-sub">さっそく予約しよう！</span>キャンペーン対象スペースはこちら</h2>
          <div className="row">

            {(()=>{
              return this.state.rooms.map((room, rowIndex)=>{
                const favClassName = room.is_favorite ? "units-item-fav__on extra-units__item-fav units-item-fav__click" : "units-item-fav extra-units__item-fav";
                const latestUpdatedFavoriteListPopup = [];
                if (this.state.isOpenDefaultFavoriteList && room == this.state.targetFavoriteRoom && Object.keys(this.state.latestUpdatedFavoriteList).length !== 0) {
                  latestUpdatedFavoriteListPopup.push(
                    <div className="units-item__baloon-s">
                      <p className="units-item__baloon-text">{this.state.latestUpdatedFavoriteList.name}</p>
                    </div>
                  );
                }

                return(
                  <div key={room.id} className="col-sm-12 col-md-3">
                    <a onClick={this.trackPageEvent.bind(this, 'promotion_' + promotion.id + ' select room_' + room.uid)} href={Routes.space_room_path(room.space.username, room.uid)} className="a__extra-units">
                      <div className="extra-units">
                        <div className="extra-units__image">
                          <img src={SMFormatHelper.roomImageURL(room, {width: 490, height: 490})} alt={sprintf("%s の写真", SMFormatHelper.roomName(room))} className="extra-units__image-pict" />
                          <p className="extra-units__item-price">{room.min_price_text}<span className="extra-units__item-per">{SMFormatHelper.priceUnit(room.min_price_unit_text, true)}</span></p>
                        </div>
                        <div className="extra-units__body">
                          <div className="extra-units__body-inner link__subcolor">
                            <h3 className="extra-units__body-title">{SMFormatHelper.roomName(room)}</h3>
                          </div>
                            <p className="extra-units__body-access">{room.space.access}</p>
                        </div>
                      </div>
                    </a>
                    <a href="#" onClick={this.favoriteDidSelect.bind(this, rowIndex)} aria-label="favorite" className={favClassName}><i className="fa fa-heart"></i></a>
                    <CSSTransitionGroup transitionName="js-favoritelist-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                      {latestUpdatedFavoriteListPopup}
                    </CSSTransitionGroup>
                  </div>
                );
              });
            })()}
          </div>
          <div className="mod-more__area">
            <a href={moreUrl} className="button-blue mod-more__area-button">キャンペーン対象スペースをすべて見る</a>
          </div>
        </div>
      </div>
    );
  }

  renderArticles(promotion) {
    let articleComponents = promotion.articles.map((article)=> {
      return(
        <div key={article.id} className="row campaign-about__casette">
          <div className="col-sm-3">
            <img src={article.image} alt="" className="w100pa" />
          </div>
          <div className="col-sm-9">
            <p className="campaign-about__discription" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(article.content)}} />
          </div>
        </div>
      );
    });

    if (articleComponents.length > 0) {
      return (
        <div className="campaign-about__border">
          {articleComponents}
        </div>
      );
    }
    return null;
  }

  renderPointDescription() {
    return (
      <ul className="campaign-attention__list">
        <li>ダッシュボードのポイント画面より、ポイントコードを入力することでポイントが獲得できます。</li>
        <li>ポイントコードの有効期限はキャンペーンにより異なります。ポイントコードの有効期限内に入力した場合に限りポイントを獲得できます。</li>
        <li>一度利用したポイントコードを再度利用することはできません。 </li>
        <li>このキャンペーンは予告なく終了する場合がございます。ご了承ください。</li>
      </ul>
    );
  }

  render() {
    const promotion = this.props.promotion;
    const coupon = promotion.coupon;
    const pointCode = promotion.point_code;
    const startedAt = moment(promotion.started_at).utc();
    const endedAt = moment(promotion.ended_at).utc();
    let isPointCodePampaign = false;
    if (promotion.coupon_type == this.promotionCouponType.pointCode) {
      isPointCodePampaign = true;
    }

    return (
      <div className="site-main">
        <div className="page__odd campaign__padding">
          <div className="campaign__heroimg"><img src={promotion.image} alt="" className="campaign__img" /></div>
          <div className="container">
            <h1 className="campaign-about__title campaign-option__title" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(promotion.title)}} />
            {(()=>{
              if ((coupon && (coupon.coupon_type == SMConst.CouponType.Normal)) || pointCode) {
                return (
                  <p className="campaign-about__date">{moment(startedAt).format("YYYY年M月D日")}〜{moment(endedAt).format("YYYY年M月D日")}</p>
                );
              }
            })()}
            <h2 className="campaign-about__heading" dangerouslySetInnerHTML={{__html: SMFormatHelper.nl2br(promotion.description)}} />
            <ul className="row campaign-about__social">
              <li className="col-xs-4">
                <a href={this.state.mailUrl} className=" social-link__mail"><i className="fa fa-envelope"></i></a>
              </li>
              <li className="col-xs-4">
                <a href={this.state.lineUrl} target="_blank" className="social-link__line"><i className="icon-spm-line"></i></a>
              </li>
              <li className="col-xs-4">
                <a href={this.state.fbUrl} className="social-link__facebook"><i className="fa fa-facebook-square"></i></a>
              </li>
            </ul>

            {(()=>{
              if (moment().unix() > moment(promotion.ended_at).unix() + 60 * 60 * 24) {
                return (
                  <div className="campaign-about__closed">このキャンペーンは終了しました。</div>
                );
              }
            })()}

            {this.renderArticles(promotion)}

            {(()=>{
              if (promotion.coupon_type == this.promotionCouponType.external) {
                return(
                  <div className="ta-c clearfix pt40">
                    <p><a target="_blank" href={promotion.external_url_link} className="button-blue pt15 pb15 w250">公式サイトへ(外部サイト)</a></p>
                  </div>
                );
              }
            })()}

          </div>
        </div>


        {(()=>{
          if (!coupon) return null;
          const backgroundImage = sprintf('url(%s)', promotion.background_image) || 'none';
          let validAt = moment(coupon.valid_at).utc();
          let expiresAt = moment(coupon.expires_at).utc();
          let couponDate = sprintf("有効期限：%s〜%s", moment(validAt).format("YYYY年M月D日"), moment(expiresAt).format("YYYY年M月D日"));
          if (coupon.coupon_type == SMConst.CouponType.FirstLimited) {
            if (coupon.valid_at_for_user && coupon.expires_at_for_user) {
              validAt = moment(coupon.valid_at_for_user).utc();
              expiresAt = moment(coupon.expires_at_for_user).utc();
              couponDate = sprintf("有効期限：%s〜%s", moment(validAt).format("YYYY年M月D日"), moment(expiresAt).format("YYYY年M月D日"));
            } else {
              couponDate = "有効期限：クーポン発行時より1ヶ月間";
            }
          }
          let conditions = [];
          if (coupon.min_order_amount > 0) {
            conditions.push(
              `利用料金が${Math.floor(coupon.min_order_amount)}円以上の予約リクエストで利用可能`
            );
          }
          if (coupon.discount_type == SMConst.CouponDiscountType.Percentage) {
            conditions.push(`${Math.floor(coupon.percentage)}%OFF`);
          }
          else if (coupon.discount_type == SMConst.CouponDiscountType.Amount) {
            conditions.push(`最大${Math.floor(coupon.amount)}円引き`);
          }
          const text = conditions.join('<span className="campaign-coupon__conditions-separator">/</span>');

          return(
            <span>
              <div className="page__odd campaign-coupon campaign__padding"
                style={{backgroundColor:promotion.background_color, backgroundImage: backgroundImage, backgroundRepeat: 'repeat'}}>
                <div className="campaign-coupon__inner">
                  {promotion.coupon_tags.map((tag)=>{
                    return(
                      <div key={tag} className="campaign-coupon__points"><p className="campaign-coupon__points-inner">{tag}</p></div>
                    );
                  })}
                  <h2 className="campaign-coupon__name">{coupon.description}</h2>
                  <p className="campaign-coupon__date">{couponDate}</p>
                  <dl className="campaign-coupon__coupon">
                    <dt className="campaign-coupon__coupon-title">クーポンコード</dt>
                    <dd className="campaign-coupon__coupon-code">{coupon.code}</dd>
                  </dl>
                  <p className="campaign-coupon__howto">予約リクエスト送信時にこのクーポンコードを入力してください。</p>
                  <p className="campaign-coupon__conditions" dangerouslySetInnerHTML={{__html: text}} />
                  <p className="campaign-coupon__attention">ご利用の前に必ず<a href="#campaign-attention" className="link-hover-border">クーポン利用上の注意</a>をご確認ください</p>
                </div>
              </div>

              <div className="page__even campaign__padding" id="campaign-attention">
                <div className="container">
                  <h2 className="campaign-attention__title">クーポン利用上の注意</h2>
                  {this.renderCouponDescription(promotion, coupon)}
                </div>
              </div>
            </span>
          );
        })()}

        {(()=>{
          if (!pointCode) return null;
          const backgroundImage = sprintf('url(%s)', promotion.background_image) || 'none';
          const validAt = moment(pointCode.valid_at).utc();
          const expiresAt = moment(pointCode.expires_at).utc();
          const pointDate = sprintf("有効期限：%s〜%s", moment(validAt).format("YYYY年M月D日"), moment(expiresAt).format("YYYY年M月D日"));

          return(
            <span>
              <div className="page__odd campaign-coupon campaign__padding"
                style={{backgroundColor:promotion.background_color, backgroundImage: backgroundImage, backgroundRepeat: 'repeat'}}>
                <div className="campaign-coupon__inner ta-c">
                  {promotion.coupon_tags.map((tag)=>{
                    return(
                      <div key={tag} className="campaign-coupon__points"><p className="campaign-coupon__points-inner">{tag}</p></div>
                    );
                  })}
                  <h2 className="campaign-coupon__name">{pointCode.description}</h2>
                  <p className="campaign-coupon__date">{pointDate}</p>
                  <dl className="campaign-coupon__coupon">
                    <dt className="campaign-coupon__coupon-title">ポイントコード</dt>
                    <dd className="campaign-coupon__coupon-code">{pointCode.code}</dd>
                  </dl>
                  {(()=>{
                    if (this.props.currentUser) {
                      return(
                        <p className="button-blue pt15 pb15 w250 mb15" onClick={this.pointCodeDidSelect.bind(this)}>
                          ポイントコードを入力する
                        </p>
                      );
                    } else {
                      return(
                        <p className="mb20 campaign-coupon__nologin">ポイントコードを利用するには<a href={Routes.new_user_registration_path()}>会員登録</a>もしくは<a href={Routes.new_user_session_path()}>ログイン</a>をしてください。</p>
                      );
                    }
                  })()}
                  <p className="campaign-coupon__attention mb5">ポイント画面よりポイントコードを入力することで獲得できます。</p>
                  <p className="campaign-coupon__attention">ご利用の前に必ず
                    <a href="#campaign-attention" className="link-hover-border">
                      ポイントコード利用上の注意
                    </a>
                    をご確認ください
                  </p>
                </div>
              </div>

              <div className="page__even campaign__padding" id="campaign-attention">
                <div className="container">
                  <h2 className="campaign-attention__title">ポイントコード利用上の注意</h2>
                  {this.renderPointDescription()}
                </div>
              </div>
            </span>
          );
        })()}
        {this.renderCampaignRooms(promotion, isPointCodePampaign)}

        <SMUFavoriteListSelectView
          room={this.state.targetFavoriteRoom}
          delegate={this}
          user={this.props.currentUser}
          isOpen={this.state.isSMUFavoriteListSelectViewOpen}
          noFavoriteListImage={this.props.noFavoriteListImage} />
      </div>

    );
  }

}
export default SMPromotionView;



// WEBPACK FOOTER //
// ./app/javascript/components/promotions/SMPromotionView.jsx